import React from 'react'
import TopHeader from './TopHeader'
import Navbar from './Navbar'
import 'bootstrap/dist/css/bootstrap.min.css'
import '../Assets/css/style.css'
import '../Assets/css/custom.css'
import '../Assets/css/media.css'
import '../Assets/css/fontawesome/css/all.min.css'

const Layout = ({ children }) => {
    return (

    <React.Fragment>

        <div className="page-flex">
            <div className="sidebar-div ">
                <div className="">
                    <Navbar/>   
                    <div id="content"> 
                        <TopHeader/>
                        <main>{children}</main>
                    </div>

                </div>
            </div>
        </div>

</React.Fragment>
    );
};

    

export default Layout